import {Injectable} from '@angular/core';
import {NoteApi} from '../api/note.api';
import {CplNote} from '../model/cpl-note.model';

@Injectable()
export class NoteService {

    constructor(private noteApi: NoteApi) { }

    getNotes = (typeOfNote: number, typeId: string, notesToInclude: number, offset?: number, limit?: number, orderBy?: string, ascending?: boolean, searchBy?: string) =>
        this.noteApi.getNotes(typeOfNote, typeId, notesToInclude, offset, limit, orderBy, ascending, searchBy);

    deleteNote = (note: CplNote) => this.noteApi.deleteNote(note);

    removeNote = (note: CplNote) => this.noteApi.removeNote(note);

    restoreNote = (note: CplNote) => this.noteApi.restoreNote(note);

    createNote = (note: CplNote) => this.noteApi.createNote(note);

    createRequestNote = (note: CplNote) => this.noteApi.createRequestNote(note);

    updateNote = (note: CplNote) => this.noteApi.updateNote(note);
}